import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";
import { Pie, Bar } from "../components/Charts";
import { getPatientSummaries, getTransactionSummaries } from "../services/get.service";
import { MenuItem, TextField } from "@mui/material";

interface transactionSummary {
  branch: string;
  periods: period[];
}

interface transactionSummary2 {
  branch: string;
  totals: number[];
}

interface period {
  name: string;
  total: number;
}

interface patientSummary {
  femaleCount: number;
  maleCount: number;
}

const Home = () => {
  const { t } = useTranslation();
  const [patientCount, setPatientCount] = useState<patientSummary>()
  const [moneyFlows, setMoneyFlows] = useState<transactionSummary[]>([])
  const [branch, setBranch] = useState<string>("All")
  const moneyFlows2: transactionSummary2[] = []
  var allTotals: number[] = []
  var dailyTotal: number = 0
  var weeklyTotal: number = 0
  var monthlyTotal: number = 0
  var yearlyTotal: number = 0

  useEffect(() => {
    getTransactionSummaries()
      .then((res) => {
        setMoneyFlows(res.data)
      })
      .catch((err) => {
        console.log(err);
      })

    getPatientSummaries()
      .then((res) => {
        setPatientCount(res.data)
      })
      .catch((err) => {
        console.log(err);
      })
  }, [])

  moneyFlows.forEach((money) => {
    var totals: number[] = []
    money.periods.forEach((period) => {
      totals.push(period.total)
    })

    dailyTotal += money.periods[0].total;
    weeklyTotal += money.periods[1].total;
    monthlyTotal += money.periods[2].total;
    yearlyTotal += money.periods[3].total;

    moneyFlows2.push({
      branch: money.branch,
      totals: totals
    })
  })

  allTotals.push(dailyTotal)
  allTotals.push(weeklyTotal)
  allTotals.push(monthlyTotal)
  allTotals.push(yearlyTotal)

  var barDataSets = [
    {
      label: "Money Flows",
      data: branch === "All" ? allTotals : moneyFlows2.filter((mon) => mon.branch === branch)?.at(0)?.totals,
      backgroundColor: ["#374151", "#fde047", "#ef4444", "#60a5fa"],
      borderColor: ["white", "white", "white", "white"],
      borderWidth: 1
    }
  ]
  var barData = {
    labels: ["Daily", "Weekly", "Monthly", "Yearly"],
    datasets: barDataSets
  }

  const barDataOptions = {
    responsive: true,
    scales: {
      x: {
        title: {
          display: true,
          text: t("Transactions"),
          font: {
            size: 14,
          },
        },
      },
      y: {
        title: {
          display: true,
          text: t("ETB"),
          font: {
            size: 14,
          },
        },
      },
    },
    plugins: {
      datalabels: {
        display: false,
      },
      legend: {
        // display: false,
        position: "top" as const,
      },
      title: {
        display: true,
        text: "Cash Flow",
        font: {
          size: 20,
        },
      },
    },
  };

  var pieDataSetsStaff = [{ data: [4, 9], backgroundColor: ["#60a5fa", "#f472b6"] }]
  var pieDataStaff = { labels: ["Male", "Female"], datasets: pieDataSetsStaff }
  const pieDataOptionsStaff = {
    responsive: true,
    plugins: {
      datalabels: {
        display: false,
      },
      legend: {
        // display: false,
        position: "top" as const,
      },
      title: {
        display: true,
        text: t("Staffs By Gender"),
        font: {
          size: 20,
        },
      },
    }
  };

  var pieDataSetsPatient = [{ data: [patientCount?.maleCount, patientCount?.femaleCount], backgroundColor: ["#60a5fa", "#f472b6"] }]
  var pieDataPatient = { labels: ["Male", "Female"], datasets: pieDataSetsPatient }
  const pieDataOptionsPatient = {
    responsive: true,
    plugins: {
      datalabels: {
        display: false,
      },
      legend: {
        // display: false,
        position: "top" as const,
      },
      title: {
        display: true,
        text: t("Patients By Gender"),
        font: {
          size: 20,
        },
      },
    }
  };

  return (
    <>
      <Helmet>
        <title>{t("Home")}</title>
      </Helmet>
      <div className="dark:text-black w-full">
        <div className="lg:m-12 m-4">
          <div className="bg-amber50 shadow-md rounded w-full lg:px-20 lg:py-10 pt-5">
            <div className="lg:grid lg:grid-cols-3 lg:gap-2 sm:grid sm:grid-cols-1 sm:gap-4">
              <div className="">
                <Bar data={barData} options={barDataOptions} />
                <TextField fullWidth defaultValue="All" size="small" select label="Branch" onChange={(e) => { setBranch(e.target.value) }}
                  disabled={moneyFlows2.length === 1}>
                  <MenuItem value="All">All</MenuItem>
                  {moneyFlows2.map((money) => (
                    <MenuItem value={money.branch}>{money.branch}</MenuItem>
                  ))}
                </TextField>
              </div>
              <div><Pie data={pieDataStaff} options={pieDataOptionsStaff} /></div>
              {/* date by remaining money bar chart to show how much money is expected on every date */}
              <div><Pie data={pieDataPatient} options={pieDataOptionsPatient} /></div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Home;
